<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats annulés contenant des documents"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID"
      bdTable="mandat_canceled"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      @cleanWarrant="cleanWarrant"
    >
      <template v-slot:menu>
        <b-row class="mb-3">
          <b-col lg="12">
            <b-button
              v-if="$store.getters.isAdmin"
              variant="secondary"
              :to="{ name: 'addWarrantsPayments' }"
              class="mr-2"
              size="sm"
              icon
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'warrantView', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(realCreancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.realCreancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(n_doc)="data">
        <b-link
          :to="{
            name: 'warrantView',
            params: { id: data.item.ID, tab: 'documents' },
          }"
        >
          {{ data.item.n_doc }}
        </b-link>
      </template>
    </bd-table-list>
     <b-modal size="xl" id="google-route" hide-footer>
      <template #modal-title>Tournée négociateur</template>
      <GoogleRoute :data="googleData"></GoogleRoute>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import GoogleRoute from "@/components/GoogleRoute";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageTribunal",
  components: {
    BdTableList,
    GoogleRoute
  },
  data() {
    return {
      Api: gestion.canceled,
      urlGoogleMaps: null,
      computeRoute: false,
      selectedWarrants: [],
      googleData: {},
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats annulés contenant des documents",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
          icon: "pencil-square",
          variant: "success",
        },
        {
          label: "Nettoyer",
          event: "cleanWarrant",
          icon: "check-circle-fill",
          variant: "warning",
        },
      ],
      fields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "date_creation",
          label: "Date de création",
          formatter: (value) => this.toDate(value),
          sortable: true,
          thStyle: { width: "100px" },
        },

        {
          key: "vendeur",
          label: "Vendeur",
          sortable: true,
          formatter: (value, key, item) => {
            return item.prenom + " " + item.nom;
          },
        },
        {
          key: "realCreancier_nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate",
        },
        {
          key: "adresse",
          label: "Adresse",
          sortable: true,
          class: "text-truncate",
          formatter: (value, key, item) => {
            let a =
              item.realCreancier_address1 +
              ", " +
              item.realCreancier_codepostal +
              " " +
              item.realCreancier_localite;
            if (item.realCreancier_pays) {
              a += " (" + item.realCreancier_pays + ")";
            }

            return a;
          },
        },
        {
          key: "realCreancier_telephone",
          label: "Téléphone",
          sortable: true,
          thStyle: { width: "200px" },
        },
        {
          key: "n_doc",
          label: "Nmbre de documents",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: "width:100px",
        },
      ],
    };
  },
  methods: {
    cleanWarrant(payload) {
      warrants.cleanWarrant(payload.ID).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Mandat nettoyé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          this.$refs.resource.submitSearch(true);
        } else {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    deleteRoute() {
      this.$store.commit("deleteRoute");
      this.urlGoogleMaps = "";
      this.refreshRoute();
    },
    refreshRoute() {
      let routes = this.$store.getters.getRoute;
      this.$refs.resource.rows.forEach((el, index) => {
        if (routes.includes(el.ID)) {
          this.$refs.resource.rows[index]._rowVariant = "success";
        } else {
          this.$refs.resource.rows[index]._rowVariant = null;
        }
      });
    },
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    createRoute() {
      this.computeRoute = true;
      this.urlGoogleMaps = null;
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: this.$store.getters.getRoute,
        })
        .then((response) => {
          this.computeRoute = false;
          if (response.statusText == "OK" && response.data.url) {
            this.urlGoogleMaps = response.data.url;
            this.googleData = response.data;
            this.$bvModal.show("google-route");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>